var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpCheckDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Power Play"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 8.8382C0.104157 8.33304 0.41142 7.95286 0.781177 7.61435C0.937413 7.47374 1.07802 7.31751 1.22905 7.16648C1.94253 6.46863 2.93723 6.46342 3.64549 7.16648C4.89017 8.40595 6.12964 9.65062 7.37431 10.8901C7.41598 10.9318 7.45764 10.9682 7.50972 11.0203C7.57221 10.963 7.6295 10.9057 7.68679 10.8484C11.1188 7.41645 14.5507 3.98448 17.9827 0.55251C18.566 -0.0307688 19.3159 -0.166173 19.9929 0.193169C20.1544 0.276494 20.295 0.396275 20.4304 0.521263C20.6595 0.729577 20.8731 0.958722 21.0918 1.17745C21.8626 1.95342 21.8678 2.9325 21.097 3.70326C19.9981 4.80211 18.9045 5.90097 17.8056 6.99462C14.6861 10.1297 11.5562 13.2545 8.4263 16.3844C7.81698 16.9937 7.21287 16.9937 6.60876 16.3844C4.67144 14.4471 2.73933 12.5097 0.796801 10.5776C0.442667 10.2235 0.114573 9.85894 0 9.34336C0 9.17671 0 9.00485 0 8.8382Z",
    fill: "#262C38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpCheckDark);
export default __webpack_public_path__ + "static/media/pp-check-dark.13da9f0c54e5d37e771b4436716bb08b.svg";
export { ForwardRef as ReactComponent };